const ContentHeading = () => {
  return (
    <div className="text-[28px] leading-[36px] sm:text-[72px] sm:leading-[80px] tracking-[0.04em] text-[#F8FAFC] font-gilroy-bold text-center">
      Become an AI Native <span className="block">Software Engineer</span>
    </div>
  );
};

export default ContentHeading;
